<div class="d-flex mb-2" *ngIf="!isCommunity">
    <input [(ngModel)]="params.postalCode" class="form-control mr-1" [readonly]="readonly"
        [ngModelOptions]="{standalone: true}" placeholder="Enter Postalcode">
    <button (click)="geocodePostalCode()" class="btn btn-sm btn-success text-nowrap">
        <i class="fa-solid fa-search"></i> Search
    </button>
</div>

<div [attr.id]="mapName" style="height: 230px;"></div>